<!--License Detail Popup -->
<ng-template #content let-closeResult="close" let-dismissResult="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">License Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismissResult('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4 class="modal-title">Library Name</h4>
    <p *ngIf="popupData.productName?.length > 0">{{popupData.productName}}</p>

    <div *ngIf="popupData.productDescription?.length > 0">
      <h4 class="modal-title">Notice</h4>
      <p>{{popupData.productDescription}}</p>
    </div>

    <div *ngIf="popupData.productLink?.length > 0">
      <h4 class="modal-title">Notice</h4>
      <p>{{popupData.productLink}}</p>
    </div>

    <h4 class="modal-title">License Type</h4>
    <p *ngIf="popupData.licenseType?.length > 0">{{popupData.licenseType}}</p>

    <h4 class="modal-title">License</h4>
    <p *ngIf="popupData.licenseLink?.length > 0">{{popupData.licenseLink}}</p>

    <div *ngIf="popupData.copyrightText?.length > 0">
      <h4 class="modal-title">Copyright</h4>
      <p>{{popupData.copyrightText}}</p>
    </div>

    <div *ngIf="popupData.noticeText?.length > 0">
      <h4 class="modal-title">Notice</h4>
      <p>{{popupData.noticeText}}</p>
    </div>

    <h4 class="modal-title">Changes</h4>
    <p *ngIf="popupData.changesText?.length > 0">{{popupData.changesText}}</p>
    <p *ngIf="popupData.changesText?.length === 0">None</p>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeResult('Close click')">Close</button>
  </div>
</ng-template>

<!-- List of licenses -->
<div class="container-fluid">
  <!-- <div class="back">
    <a class="btn btn-primary btn-sm" [routerLink]="['/about']">Back</a>
  </div> -->
  <h1>Acknowledgements and License Information</h1>
  <h2>MatrixCare - Copyright © 2002-{{year}} MatrixCare. All Rights Reserved.</h2>
  <div class="alert alert-warning" role="alert">
    <i class="fa fa-exclamation-triangle alert-icon" aria-hidden="true"></i>
    Warning: This software is protect by copyright law. Unauthorized distribution or reproduction may result in severe civil and criminal penalties.
  </div>
  <p>The use of this product is subject to the terms of your contract agreement. </p>
  <p>MatrixCare acknowledges third-parties whose software has been used in permissible forms within MatrixCare products. Additional details regarding these and other third party code included in or used by this product, including applicable copyright, legal and licensing notices, are available below.</p>
  <div>
    <table class="table table-bordered table-striped table-hover" role="grid">
      <thead>
        <tr role="row">
          <th valign="top" class="sorting_disabled" rowspan="1" colspan="1">Product Name</th>
          <th valign="top" class="sorting_disabled" rowspan="1" colspan="1">License</th>
          <th valign="middle" class="sorting_disabled details-control" rowspan="1" colspan="1">Detail</th>
          <th valign="top" class="sorting_disabled" rowspan="1" colspan="1">Copyright</th>
          <th valign="top" class="sorting_disabled" rowspan="1" colspan="1">Link</th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th rowspan="1" colspan="1"></th>
          <th rowspan="1" colspan="1"></th>
          <th rowspan="1" colspan="1"></th>
          <th rowspan="1" colspan="1"></th>
          <th rowspan="1" colspan="1"></th>
        </tr>
      </tfoot>
      <tbody>
        <tr *ngFor="let license of licenses">
          <td>{{ license.productName }}</td>
          <td>{{ license.licenseType }}</td>
          <td><button  style="padding-left:0px" class="btn btn-link" (click)="open(content, license)">Details</button></td>
          <td>{{ license.copyrightText }}</td>
          <td><a target="_blank" href="{{ license.productLink }}">{{ license.productLink }}</a></td>
        </tr>
      </tbody>
    </table>
  </div>
  <p>This product includes software components obtained under the Eclipse Public License v.1.0 (EPL) and distributed in unmodified, object code form, under the MatrixCare license agreement. Except as expressly set forth in the EPL, all Contributors to the components obtained under the EPL are disclaimed from all i) warranties and conditions, express and implied, including warranties or conditions of title and non-infringement, and implied warranties or conditions of merchantability and fitness for a particular purpose; and ii) liability for damages, including direct, indirect, special, incidental and consequential damages, such as lost profits. Any provisions in the MatrixCare license agreement that differ from the EPL are offered by MatrixCare alone and not by any other party. Upon request, MatrixCare will provide instructions for obtaining source code for the components obtained under the EPL.</p>
</div>
<div style="margin-top:100px;" id="yearDiv" align="center">© Copyright 2002-{{year}} MatrixCare.<br>All Rights Reserved.</div>
